import { render, staticRenderFns } from "./ClientProjectsNew.vue?vue&type=template&id=5876ceea&scoped=true"
import script from "./ClientProjectsNew.vue?vue&type=script&lang=ts"
export * from "./ClientProjectsNew.vue?vue&type=script&lang=ts"
import style0 from "./ClientProjectsNew.vue?vue&type=style&index=0&id=5876ceea&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5876ceea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5876ceea')) {
      api.createRecord('5876ceea', component.options)
    } else {
      api.reload('5876ceea', component.options)
    }
    module.hot.accept("./ClientProjectsNew.vue?vue&type=template&id=5876ceea&scoped=true", function () {
      api.rerender('5876ceea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientProjectsNew.vue"
export default component.exports